/**
 * What Defera keeps on a trip — the ONE definition of the arithmetic, shared
 * by the Risk Review "Net profit" column (client), the server that stores
 * its inputs, and the backer-assignment script.
 *
 * It is the founder's "net": the bar they chose for backer assignment on
 * 2026-09-01 and again on 2026-09-27, and asked for as the Risk Review
 * column on 2026-10-03.
 *
 *   trip margin = sold + skip fees + seat margin − ticket cost − refunds
 *                 (the trip page's "Net Margin" line)
 *   net profit  = trip margin − backer's cut − miles liability − card processing
 *
 * The parts come from a booking row via server/trip-net-profit.js. The
 * ticket cost is the one input left to the caller: the actual cost once an
 * admin enters it, and before that whatever the caller can price (Risk
 * Review: today's live fare). Dependency-free so the Vite client can import
 * it beside the server and scripts.
 */

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/** The trip page's Net Margin line, given what the ticket costs. */
export function tripMarginDollars(parts, ticketCost) {
  return num(parts?.sold) + num(parts?.skip_fees) + num(parts?.seat_margin)
    - num(ticketCost) - num(parts?.refunded);
}

/** Trip margin less the backer's cut, the miles liability and card processing. */
export function netProfitDollars(parts, ticketCost) {
  return tripMarginDollars(parts, ticketCost)
    - num(parts?.backer_cut) - num(parts?.miles) - num(parts?.processing);
}
